export default __webpack_public_path__ + "static/media/minimize.fd192388.svg";